import { createEntityAdapter, EntityState } from '@ngrx/entity';
import { createReducer, on } from '@ngrx/store';
import { LookBook } from '@epicuro-next/models/engagement';

import {
  loadLookbook,
  loadLookbookError,
  loadLookbookSuccess,
  updateLookBook,
  upsertLookbookEntity,
} from './lookbook-entities.actions';
import { LookBookEntity } from './model';

export interface State extends EntityState<LookBookEntity> {}

const adapter = createEntityAdapter<LookBookEntity>({
  selectId: ({ lookBookId }) => lookBookId,
});

export const initialState = adapter.getInitialState();

export const reducer = createReducer<State>(
  initialState,
  on(upsertLookbookEntity, (state, { lookBookEntity }) =>
    adapter.upsertOne(lookBookEntity, state),
  ),
  on(loadLookbook, (state, { lookBookId }) =>
    adapter.upsertOne(
      {
        lookBookId,
        loading: false,
        error: undefined,
      },
      state,
    ),
  ),
  on(loadLookbookSuccess, (state, { lookBookId, lookBook }) =>
    adapter.upsertOne(
      {
        lookBookId,
        loading: false,
        lookBook,
        error: undefined,
      },
      state,
    ),
  ),
  on(loadLookbookError, (state, { lookBookId, error }) =>
    adapter.upsertOne(
      {
        lookBookId,
        loading: false,
        error,
        lookBook: undefined,
      },
      state,
    ),
  ),
  on(updateLookBook, (state, { lookBookId, partialLookBook }) =>
    adapter.updateOne(
      {
        id: lookBookId,
        changes: {
          lookBook: {
            ...state.entities[lookBookId]?.lookBook,
            ...partialLookBook,
          } as LookBook,
        },
      },
      state,
    ),
  ),
);
